import { render, staticRenderFns } from "./InsLocation.vue?vue&type=template&id=82147ff8&scoped=true"
import script from "./InsLocation.vue?vue&type=script&lang=ts"
export * from "./InsLocation.vue?vue&type=script&lang=ts"
import style0 from "./InsLocation.vue?vue&type=style&index=0&id=82147ff8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82147ff8",
  null
  
)

export default component.exports